const Page = ({ children }) => (
  <div className="page">
    <div className="page-inner">{children}</div>
  </div>
);

export default Page;
